import { useEffect } from 'react';
import { useVisualViewport } from '@/hooks/useVisualViewport';

export function VisualViewportProvider({ children }: { children: React.ReactNode }) {
  useVisualViewport();
  return <>{children}</>;
}
